import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ReasonProofreadTipsDialog',
  props: {
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any) {




return { __sfc: true, }
}

})